<template>
  <div class="mistake-record">
    <common-breadcrumb/>
    <div
      class="main-container">
      <div class="main-title">
        <div class="top-left">您一共完成{{ examCount }}次考试，平均分为：{{ averageScore }}分，继续努力吧！您做题正确率为：<span>{{ accuracy }}%</span></div>
        <div class="top-right">排序：
          <el-select
            v-model="orderValue"
            @change="changeOrder"
            size="small">
            <el-option
              v-for="(item, idx) in orderOptions"
              :key="idx"
              :value="item.value"
              :label="item.label"/>
          </el-select>
        </div>
      </div>
      <div class="main-table">
        <el-table
          :data="recordList"
          stripe
        >
          <el-table-column
            prop="examName"
            label="考试记录"
            width="200"
            align="left"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            prop="createTime"
            label="考试时间"
            min-width="200"
            align="center"
            :show-overflow-tooltip="true"/>
           <el-table-column
             prop="spendTime"
             label="用时"
             width="80"
             align="center"
             :show-overflow-tooltip="true"/>
          <el-table-column
            prop="errorQuesNum"
            label="错题数"
            width="80"
            align="center"
            :show-overflow-tooltip="true"/>
          <el-table-column
            prop="lastScore"
            label="得分"
            width="80"
            align="center"
            class-name="score"
            :show-overflow-tooltip="true"/>
          <el-table-column
            label="操作"
            min-width="270"
            align="center" >
            <template slot-scope="scope">
              <!--<el-button size="mini" @click="parseQuestion(scope.row.bizID)">解析</el-button>-->
              <el-button size="mini" @click="parseQuestion(scope.row)">解析</el-button>
              <el-button size="mini" type="Success" @click="retryQuestion(scope.row)">重做</el-button>
              <el-button size="mini" type="danger" @click="deleteReport(scope.row.bizID)">删除记录</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="recordsParams.pageNum"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="recordsCount"/>
      </div>
    </div>
  </div>
</template>
<script>
  import { CommonBreadcrumb } from '@components/common/'
  import { getRecordList, quesAnalyStatistics,deleteRecord } from '@/api'
  import { timestampToTime, secondsToMinutes,getCookie,LoadingOptions } from '@/utils'
  export default {
    name: 'mistakeRecord',
    components: {
      CommonBreadcrumb
    },
    data() {
      return {
        loadingInstance: null,
        courseName:'mid',
        statisticsList: {},  //  考试综合统计数据
        recordList: [],
        recordsParams: {
          flag:'',
          userID: Number(getCookie('cdeluid')) || null,
          pageNum: 1,
          pageSize: 7,
          orderType: 'desc',
          orderField: 'createTime',
          courseID: null,
          bizType: 3,
          source:'pc'
        },
        recordsCount: 0,
        pageSize: 10, //  页长
        totalPageNum: 1, //  总页数
        //其他
        siteCourseID: '',
        courseID: '',
        flag: '',
        orderValue: 'createTime,desc',  //  排序选项
        orderOptions: [
          {
            value: "createTime,desc",
            label: "时间倒序"
          },
          {
            value: "createTime,asc",
            label: "时间升序"
          }
        ]
      }
    },
    computed: {
      examCount () {  // 获取考试次数
        return this.statisticsList.total || 0
      },
      averageScore () {  // 获取平均分
        let result = this.statisticsList.sumScore / this.statisticsList.total || 0
        return Math.round(result * 100) / 100
      },
      accuracy () {  // 获取做题正确率
        let result = this.statisticsList.sumRightNum / this.statisticsList.sumQuesNum || 0
        return Math.round(result * 10000) / 100
      }
    },
    mounted(){
      this.initData()
      this.getStatisticsList()
      this.getRecordList()
    },
    methods:{
      initData() {
        const { flag } = this.$route.params
        this.flag = flag === 'paidExam' ? '' : flag
        let query = this.$route.query
        this.courseID = Number(query.courseID)
        this.siteCourseID = Number(query.siteCourseID)
        this.recordsParams.courseID = this.courseID
        this.recordsParams.siteCourseID = this.siteCourseID
        this.recordsParams.flag = this.flag
      },
      // 查看用户统计数据
      async getStatisticsList() {
        let dataParams = {
          flag: this.flag,
          userID: Number(getCookie('cdeluid')) || null,
          courseID: this.courseID,
          bizType:3,
          source:'pc'
        }
        this.loadingInstance = this.$loading(LoadingOptions)
        await quesAnalyStatistics(dataParams).then(res => {
          this.$nextTick(() => {
            this.loadingInstance.close()
          })
          this.statisticsList = res
        })
      },
      // 获取考试记录列表
      async getRecordList(flag) {
        if(flag) this.recordsParams.pageNum = 1
        this.loadingInstance = this.$loading(LoadingOptions)
        await getRecordList(this.recordsParams).then(res => {
          this.$nextTick(() => {
            this.loadingInstance.close()
          })
          res.rows.forEach((val) => {
            val.createTime = timestampToTime(val.createTime)
            val.spendTime = secondsToMinutes(val.spendTime)
          })
          this.recordList = res.rows || []
          this.recordsCount = res.total || 0
          this.pageSize = res.pageSize || 10
          this.totalPageNum = res.totalPageNum || 1
        })
      },
      // 解析试题
      parseQuestion(row) {
        const { flag } = this.$route.params
        const { majorTag } = this.$categoryInfo
        /*this.$router.push({
          name: 'analysis',
          query: {
            flag: flag,
            bizID: bizID,
            siteCourseID: this.siteCourseID,
            courseID: this.courseID,
            mistake:1
          }
        })*/
        window.location.href = '//member.jianshe99.com/qzs/index.html#/analysis/examinationFaultsAnalysis?isExamina=1&jkFlag='+ majorTag + '&siteCourseID='
          + this.siteCourseID + '&courseID=' + row.courseID + '&paperViewID=-1&bizID=' + row.bizID + '&status=2&flag=' + flag
      },
      //  重做试题
      retryQuestion(row) {
        const { flag } = this.$route.params
        const { majorTag } = this.$categoryInfo
        // this.$router.push({
        //   name:'mistakeRedo',
        //   query: {
        //     flag: flag,
        //     bizID: bizID.toString(),
        //     mistake:1,
        //     courseID:this.courseID,
        //     siteCourseID:this.siteCourseID
        //   }
        // })
        window.location.href = `//member.jianshe99.com/qzs/index.html#/erroRedoExam?bizID=${row.bizID}&courseID=${row.courseID}&jkFlag=${majorTag}&siteCourseID=${this.siteCourseID}&flag=${flag}`
      },
      // 删除考试记录
      deleteReport (bizID) {
        let deleteParams = {
          bizID:bizID,
          flag: this.flag,
          source:'pc'
        }
        this.$confirm('此操作将永久删除该次考试, 是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loadingInstance = this.$loading(LoadingOptions)
          deleteRecord(deleteParams).then(() => {
            this.$nextTick(() => {
              this.loadingInstance.close()
            })
            this.$message.success('删除成功')
            this.getRecordList(true)
            this.getStatisticsList()
          })
        })
      },
      // 列表排序
      changeOrder () {
        let arr = this.orderValue.split(',')
        this.recordsParams.orderField = arr[0]
        this.recordsParams.orderType = arr[1]
        this.getRecordList(this.recordsParams)
      },
      // 切换页码
      handleCurrentChange(val){
        this.recordsParams.pageNum = val
        this.getRecordList()
      },
    }
  }
</script>
<style lang="scss" scoped>
  .mistake-record {
    height: 518px;
    overflow: hidden;
    background-color: #ffffff;
    .main-container {
      .main-title {
        overflow: hidden;
        padding-left: 20px;
        height: 39px;
        font-size: 12px;
        line-height: 40px;
        background-color: #ffffff;
        border-bottom: 1px solid #e6e6e6;
        .top-left {
          float: left;
          span {
            color: #fd3b06;
          }
        }
        .top-right {
          float: right;
          .el-select {
            margin-right: 34px;
            width: 100px;
            .el-input--suffix {
              .el-input__inner {
                padding: 0 15px;
              }
            }
          }
          .el-input--suffix {
            .el-input__inner {
              padding: 0 15px;
            }
          }
        }
      }
      .main-table {
        margin: 0 auto;
        font-size: 14px;
        .el-table {
          height: 416px;
          .el-table__header,
          .el-table__body {
            margin: 0 auto;
          }
        }
        .score {
          color: green;
          &:first-child {
            color: green;
          }
        }
        .el-pagination {
          padding-left: 20px;
          background-color: #ffffff;
        }
      }
    }
  }
  .user-defined-style {
    top: 300px !important;
  }
</style>
